import { ComponentProps } from 'react';
import clsx from 'clsx';
import Flex from 'antd/es/flex';

interface OpFlexProps extends ComponentProps<typeof Flex> {
  testId?: string;
}

/**
 * OpFlex is a wrapper around Ant Design's Flex component.
 * It provides a flexbox container for creating flexible layouts with CSS flexbox properties.
 * 
 * Use this component when you need flexible, modern layouts with alignment and distribution controls.
 * Supports all standard flexbox properties like justify, align, gap, and wrap.
 * 
 * @example
 * <OpFlex justify="space-between" align="center" gap={16}>
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 * </OpFlex>
 * 
 */
export const OpFlex = ({
  className,
  testId = 'op-row',
  ...flexProps
}: OpFlexProps) => {
  return (
    <Flex
      className={clsx('op-flex', className)}
      data-testid={testId}
      {...flexProps}
    />
  );
};
